export async function requestHardReload() {
  try {
    // Unregister all service workers
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();

      await Promise.all(
        regs.map(reg => reg.unregister())
      );
    }

    // Delete all Cache Storage / Workbox caches
    if (window.caches?.keys) {
      const keys = await caches.keys();

      await Promise.all(
        keys.map(key => caches.delete(key))
      );
    }
  } catch (e) {
    console.error('Failed to clear PWA caches:', e);
  }

  // Android WebView
  if (window.Android?.requestHardReload) {
    try {
      window.Android.requestHardReload();
      return;
    } catch (e) {
      console.error('Android hard reload failed:', e);
    }
  }

  // Normal browser fallback
  const base = new URL('/aac/', window.location.origin);
  base.searchParams.set('t', Date.now().toString());
  window.location.replace(base.toString());
}

// export async function requestHardReload() {
//   // Android WebView bridge path
//   if (window.Android?.requestHardReload) {
//     try {
//       window.Android.requestHardReload();
//       return;
//     } catch (e) {
//       // fall through to web path
//     }
//   }

//   // Web fallback: unregister SW + clear caches + reload
//   try {
//     if ('serviceWorker' in navigator) {
//       const regs = await navigator.serviceWorker.getRegistrations();
//       await Promise.all(regs.map(r => r.unregister()));
//     }
//     if (window.caches?.keys) {
//       const keys = await caches.keys();
//       await Promise.all(keys.map(k => caches.delete(k)));
//     }
//   } finally {
//     // const url = new URL(window.location.href);
//     // url.searchParams.set('t', Date.now().toString());
//     // window.location.replace(url.toString());
//         const base = new URL('/aac/', window.location.origin);
//     base.searchParams.set('t', Date.now().toString());
//     window.location.replace(base.toString());
//   }
// }
